// kept for legacy in case porting to other runtime
// const imul = Math.imul && Math.imul(0xffffffff, 2) === -2
//   ? Math.imul
//   : (a, b) => {
//     a |= 0 // int
//     b |= 0 // int
//     const c = a & 0xffff
//     const d = b & 0xffff
//     // Shift by 0 fixes the sign on the high part.
//     return (
//       c * d + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0)) | 0 // int
//   }
const imul = Math.imul

// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
const smi = i32 => (
  ((i32 >>> 1) & 0x40000000) | (i32 & 0xbfffffff))

export {
  imul,
  smi
}
